import FAVICONS from 'shared/favicons';
import {CurrentUserClass} from 'shared/CurrentUser';
import defineSection from '~/spa/section';
import sectionHead from '~/spa/head';
import {getWikiChildren, getMainWikiPageName} from './WikiChildrenPages';
import {ROUTER_NAME_PREFIX, MAIN_URL_PREFIX} from './config';

export default defineSection({
    head: sectionHead({title: 'Wiki', icon: FAVICONS.wiki, appleIcon: FAVICONS.wiki_apple}),
    routes: [
        {
            path: MAIN_URL_PREFIX + 'list/',
            component: () => import(/* webpackChunkName: "wiki" */ './WikisSharedList.vue'),
            name: 'WikisSharedList',
            props: true,
        },
        {
            path: MAIN_URL_PREFIX + ':wikiId(\\d+)/manage-access/',
            component: () => import(/* webpackChunkName: "wiki" */ './WikiMainPageManageAccess.vue'),
            name: 'MainWikiPageManageAccess',
            props: true,
        },
        {
            path: MAIN_URL_PREFIX + ':wikiId(\\d+)/reports/',
            component: () => import(/* webpackChunkName: "wiki" */ './reports/WikiPageReports.vue'),
            name: 'MainWikiPageReports',
            props: true,
        },
        {
            path: MAIN_URL_PREFIX + ':wikiId(\\d+|my)/:accessCode([a-zA-Z0-9_@!$\-]{10,100})?/',
            component: () => import(/* webpackChunkName: "wiki" */ './WikiPageInMyStuff.vue'),
            name: 'WikiPageInMyStuff',
            props: route => ({
                accessCode: route.params.accessCode,
                wikiId: (route.params.wikiId === 'my') ? (new CurrentUserClass().wiki_id || route.params.wikiId) : route.params.wikiId
            }),
            children: getWikiChildren(ROUTER_NAME_PREFIX)
        },
        {
            path: MAIN_URL_PREFIX + ':wikiId(\\d+)/code/:accessCode/',
            redirect: to => {
                return {
                    name: getMainWikiPageName(ROUTER_NAME_PREFIX),
                    params: {
                        wikiId: to.params.wikiId,
                        accessCode: to.params.accessCode,
                    }
                };
            }
        },
    ]
});
